/**
 * Normalized output contracts for Sanestly Playwright Run Diff.
 *
 * These interfaces describe OUR normalized model, not Playwright's wire format.
 * Schema version: 1.0
 */
export const DEFAULT_COMPARISON_SETTINGS = {
    timing: { minAbsoluteMs: 100, minRelativeIncrease: 0.2 },
    match: { minimumConfidence: 0.6 },
    visuals: { maxPixelDiffRatio: 0.01, maskRects: [] },
    ignore: { urlPatterns: [], actionPatterns: [], responseHeaders: [] },
};
export const REPORT_SCHEMA_VERSION = '1.0';
//# sourceMappingURL=types.js.map